import React from 'react';

import JasspContentPage from '../../../components/JasspContentPage/JasspContentPage';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';

function NotreHistoire() {
  const { t } = useLanguage();

  return (
    <JasspContentPage pageTitleKey="pages.notreHistoire.title">
      <figure className="jassp-content-figure mb-5">
        <img
          src="/images/histoire.jpg"
          alt={t('notreHistoire.image.alt')}
          className="rounded-16 w-100 img-fluid"
        />
      </figure>
      <p className="fs-18 text-gray-700 mb-4">{t('notreHistoire.body.p1')}</p>
      <p className="fs-18 text-gray-700 mb-4">{t('notreHistoire.body.p2')}</p>
      <p className="fs-18 text-gray-700 mb-0">{t('notreHistoire.body.p3')}</p>
    </JasspContentPage>
  );
}

export default NotreHistoire;
